import Ad, { AdErrorBoundary, Location } from 'interface/Ad';
import ErrorBoundary from 'interface/ErrorBoundary';
import NavigationBar from 'interface/NavigationBar';
import { hasPremium } from 'interface/selectors/user';
import { Outlet } from 'react-router-dom';
import { useWaSelector } from 'interface/utils/useWaSelector';

import './HomeLayout.scss';
import ReportSelectionHeader from '../ReportSelectionHeader';

export function HomeLayout() {
  const premium = useWaSelector((state) => hasPremium(state));

  return (
    <div className="home-page">
      <NavigationBar style={{ margin: 0, position: 'static' }} />

      <ReportSelectionHeader />

      {premium === false && (
        <AdErrorBoundary>
          <Ad location={Location.Top} style={{ marginTop: '-20px' }} />
        </AdErrorBoundary>
      )}

      <main className="container">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
